// extracted by mini-css-extract-plugin
export default {"info-card-label":"InfoCardLabel_info-card-label__Y4HLB"};